import { cx } from "../../lib/cx.js";
/* empty css             */
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/StatCard/StatCard.tsx
/** A stat tile: a label, a large tabular value, and a hint (Pay History's stat strip). */
function StatCard({ label, value, hint, delta, tone = "neutral", className, ...rest }) {
	return /* @__PURE__ */ jsxs("div", {
		...rest,
		className: cx("ds-stat-card", className),
		children: [
			/* @__PURE__ */ jsx("span", {
				className: "ds-stat-card__label",
				children: label
			}),
			/* @__PURE__ */ jsxs("span", {
				className: "ds-stat-card__value-row",
				children: [/* @__PURE__ */ jsx("span", {
					className: cx("ds-stat-card__value", `ds-stat-card__value--${tone}`),
					children: value
				}), delta && /* @__PURE__ */ jsx("span", {
					className: "ds-stat-card__delta",
					children: delta
				})]
			}),
			hint && /* @__PURE__ */ jsx("span", {
				className: "ds-stat-card__hint",
				children: hint
			})
		]
	});
}
/** A row of StatCards that wraps to fit, each at least 160px wide. */
function StatStrip({ className, ...rest }) {
	return /* @__PURE__ */ jsx("div", {
		...rest,
		className: cx("ds-stat-strip", className)
	});
}
//#endregion
export { StatCard, StatStrip };

//# sourceMappingURL=StatCard.js.map